import React, {PropTypes} from "react";
import Banner from "./common/Banner";
import Footer from "./common/utils/Footer";
import axios from "axios";
import Constants from "../classes/constants"


class Reporting extends React.Component {

  constructor() {
    super();
    this.state = ({reporting: []})
  }

  componentDidMount() {
    axios.get(process.env.REQ_URL + "/getReporting?q=" + this.props.emp.empno, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {


      this.setState({reporting: response.data.data})

    }).catch((error) => {
      console.log(error);
    });

  }

  render() {
    console.log(this.props);
    return (<div>
        <Banner name="My Reporting"/>
        <div className="container-fluid">

          <div className="wrapper-1">

            <div className="row clearfix">
              <div className="col-md-12">
                <div className="content-wrap">

                  <div className="row clearfix text-center">
                    <div className="col-sm-12 col-md-12">
                      {this.state.reporting.map((node)=> {
                        let profilePic = Constants.defaultProfilePicture[0];
                        if(node.imageUrl){
                          profilePic = node.imageUrl;
                        }
                        return <div style={{display: 'inline'}}>
                          <div className="team-profile">
                            <div className="team-profile-wrap purple-border">

                                <img className="profile_pic" src={profilePic} height="122px" width="123px"/>

                            </div>
                            <div className="profile-info">
                              <span className="name"><a href={"#/1/profile/" + node.empId}>{node.fullName}</a></span>
                              <span className="department">{node.department}</span>
                            </div>
                          </div>
                          <div className="right-arrow">
                            <div style={{height: '7em'}} className="icon-wrapper"><span
                              className="icon-right_arrow"></span></div>
                          </div>
                        </div>


                      })}


                      <div style={{display: 'inline'}}>
                        <div className="team-profile">
                          <div className="team-profile-wrap purple-border">
                            <div className="team-profile-pic " style={{
                              "background": "url(https://hrms.quikrcorp.com/public/images/gm.png)",
                              "background-size": "140px 130px"
                            }}></div>
                          </div>
                          <div className="profile-info">
                            <span className="name">Quikr General Management</span>

                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>


    );
  }
}

Reporting.propTypes = {};

export default Reporting;







/** WEBPACK FOOTER **
 ** ./src/components/Reporting.js
 **/